import React, { FC } from 'react';
import { SxProps, Theme } from '@mui/system';

import { Stack } from '../../Stack';


export const Container: FC<{ sx?: SxProps<Theme> }> = ({ children, sx }) => (
    <Stack
        sx={{
            p: 2,
            borderRadius: ({ spacing }) => spacing(4),
            backgroundColor: 'grayscale.shade0',
            boxShadow:
                '0px 8px 24px 0px rgba(0, 0, 0, 0.05), 0px 2px 8px 0px rgba(0, 0, 0, 0.05)',

            ...sx,
        }}
    >
        {children}
    </Stack>
);
